import { render, staticRenderFns } from "./ShoppingListCardBasicData.vue?vue&type=template&id=0162ddc9&scoped=true"
import script from "./ShoppingListCardBasicData.vue?vue&type=script&lang=ts"
export * from "./ShoppingListCardBasicData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0162ddc9",
  null
  
)

export default component.exports